import React from 'react';
import { Search, ShieldCheck, MapPin, Wrench, Package, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-brand-cream overflow-hidden border-b border-brand-border" data-id="element-225">
      <div className="max-w-7xl mx-auto px-4 py-8 lg:py-12" data-id="element-226">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center" data-id="element-227">
          {/* Left Column: Content */}
          <div className="lg:col-span-7 relative z-10" data-id="element-228">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-green/10 text-brand-green text-xs font-bold tracking-wide mb-4 uppercase border border-brand-green/20" data-id="element-229">
              Residential, commercial & custom mailbox systems
            </span>

            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-4 leading-tight text-balance" data-id="element-230">
              Mailboxes made easier to choose
            </h1>

            <p className="text-base lg:text-lg text-gray-600 mb-6 leading-relaxed text-balance max-w-2xl" data-id="element-231">
              Shop residential mailboxes, complete post systems, commercial
              delivery units, replacement parts, address plaques, street signs,
              and exterior accents — with clearer paths to the right fit.
            </p>

            {/* Hero Search Panel */}
            <div className="bg-white p-2 rounded-lg shadow-sm border border-brand-border mb-3 flex flex-col sm:flex-row gap-2 max-w-2xl" data-id="element-232">
              <div className="relative flex-grow" data-id="element-233">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} data-id="element-234" />
                <input type="text" placeholder="Search 1,700+ products by name, brand, part, or spec" className="w-full pl-10 pr-4 py-3 rounded-md border-none focus:ring-2 focus:ring-brand-green/50 bg-transparent text-brand-charcoal placeholder-gray-500 font-medium" data-id="element-235" />
              </div>
              <button className="bg-brand-green hover:bg-brand-green/90 text-white px-8 py-3 rounded-md font-semibold transition-colors whitespace-nowrap shadow-sm" data-id="element-236">
                Search
              </button>
            </div>

            {/* Quick Chips */}
            <div className="flex flex-wrap gap-2 mb-8 max-w-2xl" data-id="element-237">
              {['Complete mailbox system', 'Locking mailbox', 'Commercial CBU', 'Replacement part', 'Address plaque', 'Mailbox post'].map(chip => <a key={chip} href="#" className="text-xs font-medium bg-white hover:bg-brand-green/5 text-gray-600 hover:text-brand-green px-3 py-1.5 rounded-full border border-brand-border transition-colors" data-id="element-238">
                  {chip}
                </a>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-wrap items-center gap-4" data-id="element-239">
              <a href="#shop-by-need" className="bg-brand-red hover:bg-brand-red/90 text-white px-6 py-3 rounded-md font-bold transition-colors shadow-sm" data-id="element-240">
                Shop by Project
              </a>
              <a href="/help-choosing.html" className="bg-white hover:bg-brand-cream text-brand-charcoal border border-brand-border px-6 py-3 rounded-md font-semibold transition-colors" data-id="element-241">
                Get Help Choosing
              </a>
              <span className="hidden sm:inline text-gray-400" data-id="element-242">or</span>
              <a href="tel:301-620-7585" className="text-brand-green hover:text-brand-charcoal font-semibold flex items-center gap-2 transition-colors" data-id="element-243">
                Call 301-620-7585
              </a>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="lg:col-span-5 relative hidden lg:block h-full min-h-[400px]" data-id="element-244">
            <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-sm border border-brand-border" data-id="element-245">
              <img src="https://www.midatlanticmailboxes.com/uploaded/images/Redesign/1%20571.png" alt="Beautiful home exterior with mailbox" className="w-full h-full object-cover object-center" data-id="element-246" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-green/40 to-transparent mix-blend-multiply" data-id="element-247"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Trust Strip - Compact */}
      <div className="bg-white border-t border-brand-border" data-id="element-248">
        <div className="max-w-7xl mx-auto px-4 py-3" data-id="element-249">
          <div className="flex flex-wrap justify-center lg:justify-between items-center gap-x-8 gap-y-3 text-xs lg:text-sm text-brand-charcoal font-medium" data-id="element-250">
            <div className="flex items-center gap-2" data-id="element-251">
              <Package size={16} className="text-brand-green" data-id="element-252" />
              <span data-id="element-253">Nationwide shipping</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-254"></div>
            <div className="flex items-center gap-2" data-id="element-255">
              <Wrench size={16} className="text-brand-green" data-id="element-256" />
              <span data-id="element-257">Select-area installation</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-258"></div>
            <div className="flex items-center gap-2" data-id="element-259">
              <ShieldCheck size={16} className="text-brand-green" data-id="element-260" />
              <span data-id="element-261">22+ years of expertise</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-brand-border" data-id="element-262"></div>
            <div className="flex items-center gap-2" data-id="element-263">
              <MapPin size={16} className="text-brand-green" data-id="element-264" />
              <span data-id="element-265">USPS-aware guidance</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}